import NoteTaskModal from './NoteTaskModal';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AddNoteModal({ target, onClose, onSaved }) {
  const createUrl = target.type === 'project'
    ? `${API}/zoho/project/${target.id}/notes`
    : `${API}/zoho/package/${target.module}/${target.id}/notes`;

  return (
    <NoteTaskModal
      type="note"
      mode="add"
      target={target}
      createUrl={createUrl}
      onClose={onClose}
      onSaved={onSaved}
    />
  );
}
